
import { Fragment } from 'vue-frag'
export default {
  components: {
    Fragment
  },
  props: ["element"],
  name: "hyperCoreButton",
  methods: {
    percentage(v) {
      if (v == "auto" || v == "" || !v) {
        return "auto";
      }
      return isNaN(v) ? v : v + "px";
    },
  },
};
